import React from "react";
import { Modal, Button } from "react-bootstrap";

function ModalSkeleton({ open, setOpen, title, children, fn, size, isBig }) {
  const handleClose = () => {
    setOpen(false);
    fn && fn();
  };

  return (
    <Modal
      show={open}
      onHide={handleClose}
      centered
      className={`modal-skeleton ${isBig && "modal-lg-h"}`}
      size={size && size}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
}

export default ModalSkeleton;
